import React, { FC, useEffect, useState } from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import "firebase/auth";

//Components
import Header from './Header';
import ActivityLoading from './common/ActivityLoading';
import SendNotifications from './common/SendNotifications';

//Routes
import Activities from './activities/Activities';
import Activity from './activities/Activity';
import NewUser from './users/NewUser';
import Users from './users/Users';
import ImportUsers from './users/ImportUsers';
import UserGroup from './groups/UserGroup';
import UserGroupList from './groups/UserGroupList';
import CycleList from './schoolCycle/CycleList';
import Cycle from './schoolCycle/Cycle';
import Inscriptions from './inscriptions/Inscriptions';
import MyActivities from './inscriptions/MyActivities';
import ActivityDetails from './inscriptions/ActivityDetails';
import ActivityReport from './activities/ActivityReport';
import ActivityExport from './activities/ActivityExport';
import LocationList from './locations/LocationsList';
import Location from './locations/Location';

//Services
import { registerUserToDatabase } from '../services/NewGroupService';

//Styles
import "../styles/main.css";
import ActivityView from './activities/ActivityView';

const Main: FC = () => {
    const [authorized, setAuthorized] = useState<any>(undefined);
    const [loading, setLoading] = useState<boolean>(true);
    const [success, setSuccess] = useState<boolean>(true);

    useEffect(() => {
        registerUserToDatabase().then((response: any) => {
            setAuthorized(response);
            setSuccess(response.success);
            setLoading(false);
        })
    }, []);

    const redirectTo = authorized?.admin ?
        "cycles" :
        authorized?.teacher ?
            "activities" : "inscriptions";

    return (
        !loading ?
            success ?
                <Router>
                    <Header user={authorized} />
                    <Switch>
                        <Route exact path="/">
                            <Redirect to={redirectTo} />
                        </Route>
                        {(authorized?.admin) && <Route exact path="/cycles" component={CycleList} />}
                        {(authorized?.admin) && <Route exact path="/cycle/new" component={Cycle} />}
                        {(authorized?.admin) && <Route exact path="/cycle/edit/:cycleId" component={Cycle} />}
                        {(authorized?.admin || authorized?.teacher) && <Route exact path="/activities" /* component={Activities} */ render={(props) => (
                            <Activities {...props} user={authorized} />
                        )} />}
                        {(authorized?.admin || authorized?.teacher) && <Route exact path="/activities/new" component={Activity} />}
                        {(authorized?.admin || authorized?.teacher) && <Route exact path="/activities/activityReport" component={ActivityReport} />}
                        {(authorized?.admin || authorized?.teacher) && <Route exact path="/activities/activityExport" component={ActivityExport} />}
                        {(authorized?.admin || authorized?.teacher) && <Route exact path="/activity/edit/:activityId" component={Activity} />}
                        {(authorized?.admin || authorized?.teacher) && <Route exact path="/activity/view/:activityId" component={ActivityView} />}
                        {(authorized?.admin) && <Route exact path="/users" component={Users} />}
                        {(authorized?.admin) && <Route exact path="/users/newUser" component={NewUser} />}
                        {(authorized?.admin) && <Route exact path="/user/edit/:userId" component={NewUser} />}
                        {(authorized?.admin) && <Route exact path="/users/importUsers" component={ImportUsers} />}
                        {(authorized?.admin) && <Route exact path="/userGroups" component={UserGroupList} />}
                        {(authorized?.admin) && <Route exact path="/userGroup/new" component={UserGroup} />}
                        {(authorized?.admin) && <Route exact path="/userGroup/edit/:userGroupId" component={UserGroup} />}
                        {(authorized?.admin || authorized?.teacher) && <Route exact path="/locations" component={LocationList} />}
                        {(authorized?.admin || authorized?.teacher) && <Route exact path="/locations/new" component={Location} />}
                        {(authorized?.admin || authorized?.teacher) && <Route exact path="/locations/edit/:locationId" component={Location} />}
                        {authorized?.student && <Route exact path="/inscriptions" component={Inscriptions} />}
                        {authorized?.student && <Route exact path="/myActivities" component={MyActivities} />}
                        {authorized?.student && <Route exact path="/activityDetails/:activityId" component={ActivityDetails} />}
                    </Switch>
                </Router> :
            <SendNotifications message={"Usted no está autorizado para entrar a esta página, lo sentimos."} /> :
        <ActivityLoading />
    )
}

export default Main;